import { SetupSection } from "./components/setup-section";
import { type PlatformDetails } from "./platform-details";

export const AppLovinDetails: PlatformDetails = {
  northbeamDocUrl: "https://docs.northbeam.io/docs/applovin",
  officialDocUrl: "",
  additionalDetails: [
    {
      title: "How is spend tracked for AppLovin?",
      content: (
        <>Spend is tracked through Northbeam’s Native Integration below.</>
      ),
    },
  ],
};

export const AppLovinSetup = ({
  connectionContent,
}: {
  connectionContent: React.ReactNode;
}) => (
  <>
    <SetupSection title="Connect your AppLovin account">
      {connectionContent}
    </SetupSection>
  </>
);
